import { createFileRoute } from "@tanstack/react-router";

import { PdcNotificationMappingsRoute } from "../../containers/PdcNotificationMappingsRoute";

export const Route = createFileRoute("/_layout-nosidebar/pdc-notification-mappings")({
    component: PdcNotificationMappingsPage,
});

function PdcNotificationMappingsPage() {
    return <PdcNotificationMappingsRoute />;
}
